<script>
    import { push } from 'svelte-spa-router';

    // Props
    export let label = "Mano Profilis";
    export let backLink = "/login-greeting"; // Remove the # since svelte-spa-router doesn't need it
    export let logoSrc = "/static/images/Tutory Logo Black 1.png";
    export let backIconSrc = "/static/icons/backButtonIcon.png";

    // Function to handle navigation using svelte-spa-router
    function navigate(event) {
        event.preventDefault(); // Prevent the default href behavior
        event.stopPropagation(); // Stop event bubbling
        console.log('NavbarReusable - Navigate clicked, going to:', backLink);
        
        // Force navigation to work by ensuring it happens after current event loop
        requestAnimationFrame(() => {
            try {
                push(backLink);
                console.log('NavbarReusable - Navigation attempted to:', backLink);
            } catch (error) {
                console.error('NavbarReusable - Navigation error:', error);
                // Fallback navigation method
                window.location.hash = backLink;
            }
        });
    }
</script>

<div class="site-header">
    <img src="{logoSrc}" alt="TUTORY Logo" class="header-logo" />

    <div class="top-bar">
        <a href="{backLink}" class="exit-button" on:click={navigate}>
            <img src="{backIconSrc}" alt="Exit" class="icon" />
        </a>

        <div class="label">{label}</div>
    </div>
</div>

<style>
    .site-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 16px 0;
        background-color: #fff;
    }

    .header-logo {
        max-width: 250px;
        height: auto;
        margin-bottom: 28px;
    }

    .top-bar {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px;
        width: 100%;
        max-width: 600px;
        background-color: transparent;
        border-bottom: 1px solid #000;
        margin-bottom: 30px;
    }

    .exit-button {
        position: absolute;
        left: 8px;
    }

    .icon {
        width: 40px;
        height: 40px;
    }

    .label {
        font-size: 28px;
        font-weight: 300;
        color: #14695b;
        text-align: center;
    }
</style>

